import { SET_LEADS, UPDATE_LEAD } from './constants';

const initialState = {
  list: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEADS:
      return { ...state, list: action.payload };
    case UPDATE_LEAD:
      if (!state.list) return state;
      return {
        ...state,
        list: state.list.map(lead => (lead.id === action.payload.id ? { ...lead, ...action.payload } : lead)),
      };
    default:
      return state;
  }
};

export default reducer;
